import { useEffect } from 'react';

import { ShieldXIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import { useTitle } from 'react-use';

import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import useSegments from '@/segment/useSegments';
import { PageName } from '@/shared/types/segment';
import { LOGIN_ROUTE } from '@/util/constants';

const AuthError: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const description = searchParams.get('description');
  const requestId = searchParams.get('request_id');

  useTitle(t('auth.authentication_failed'));

  useSegments(PageName.UNAUTHORIZED);

  const handleTryAgain = () => {
    window.location.href = LOGIN_ROUTE;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-muted-light px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-bg-destructive-soft">
            <ShieldXIcon className="h-8 w-8 text-red-500" />
          </div>
          <CardTitle className="text-2xl font-semibold">
            {t('auth.authentication_failed')}
          </CardTitle>
          <CardDescription className="mt-2 text-base">
            {description || t('auth.generic_error_message')}
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-2 text-center text-sm text-foreground-muted">
          {requestId && (
            <span className="text-sm leading-5 font-normal text-foreground">
              {t('auth.request_id')}: {requestId}
            </span>
          )}
        </CardContent>

        <CardFooter>
          <Button onClick={handleTryAgain} className="w-full">
            {t('auth.try_different_email')}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default AuthError;
